import type { Note } from '../../entities/note/noteTypes';
import { MOCK_GROUP_ID } from './mockSite';

/**
 * Dataset mock per Note. Audit allineato a mockTasks (userId 1 = "Jader
 * Francia") cosi' la timeline attivita' (vedi useEntityActivities)
 * mostra autore coerente. createDate distribuite su 4 mesi per popolare
 * i raggruppamenti per mese di ActivityTimeline.
 *
 * Le Relationship Note <-> Person/Business sono in relationshipMocks.ts
 * (aggiunte in Step 2.3 quando l'integrazione in timeline lo richiede).
 */
const baseAudit = { companyId: 1, groupId: MOCK_GROUP_ID, userId: 1, userName: 'Jader Francia' };
const auditAt = (iso: string) => ({ ...baseAudit, createDate: iso, modifiedDate: iso });

export const mockNotes: Note[] = [
  // --- Aprile 2026 ---
  {
    noteId: 1,
    title: 'Riassunto demo commerciale Fornari Srl',
    description: 'Il cliente ha mostrato interesse per il modulo dashboard. Vuole un secondo incontro tecnico con il responsabile IT entro fine mese.',
    ...auditAt('2026-04-09T15:30:00Z'),
  },
  {
    noteId: 2,
    title: 'Promemoria condizioni di pagamento Acme Corp',
    description: 'Il cliente ha richiesto pagamento a 60 giorni fine mese invece dei 30 standard. Da verificare con amministrazione.',
    ...auditAt('2026-04-04T10:15:00Z'),
  },

  // --- Marzo 2026 ---
  {
    noteId: 3,
    title: 'Lessons learned migrazione cliente X',
    description: 'La migrazione è richiesta una settimana extra per la fase di test. Per i prossimi clienti pianificare 4 settimane invece di 3.',
    ...auditAt('2026-03-22T09:00:00Z'),
  },
  {
    noteId: 4,
    title: 'Idea: pacchetto onboarding per PMI',
    description: 'Spunto da call con Michele: creare un offerta light per aziende <50 dipendenti. Sconto strutturato sul primo anno.',
    ...auditAt('2026-03-15T14:00:00Z'),
  },
  {
    noteId: 5,
    title: 'OPPORTUNITY BRAIN - lettura strategica Mascheroni Srl',
    description: 'Non è una opportunità AI ma di semplificazione operativa. Trigger commerciali: complessità ingestibile, frustrazione operativa, impatto su vendite. Problema core: mancanza di orchestrazione tra sistemi e dati.',
    ...auditAt('2026-03-08T05:45:00Z'),
  },

  // --- Febbraio 2026 ---
  {
    noteId: 6,
    title: 'Feedback presentazione fiera Hannover',
    description: 'Visite registrate: 47. Lead qualificati: 12. Da contattare entro 10 giorni. Il prodotto X ha generato l\'interesse maggiore.',
    ...auditAt('2026-02-26T18:00:00Z'),
  },
  {
    noteId: 7,
    title: 'Da chiarire: ruolo CTO in decisione tecnologica',
    description: 'Nella prossima call con Trentino Sicurezza verificare chi prende la decisione finale: CTO o CEO. Influenza la strategia commerciale.',
    ...auditAt('2026-02-14T11:30:00Z'),
  },

  // --- Gennaio 2026 ---
  {
    noteId: 8,
    title: 'Punti chiave call con Roberto Bianchi (Miksi)',
    description: 'Roberto cerca un partner di lungo periodo, non un fornitore singolo. Apprezza la consulenza pre-vendita. Pronto a investire se ROI < 18 mesi.',
    ...auditAt('2026-01-28T16:45:00Z'),
  },
  {
    noteId: 9,
    title: 'Roadmap 2026 - priorità commerciali',
    description: 'Q1: consolidare i 5 clienti core. Q2: aprire al mercato austriaco (AlpiSolar come pilot). Q3: lancio modulo X. Q4: review e pianificazione 2027.',
    ...auditAt('2026-01-12T09:00:00Z'),
  },
  {
    noteId: 10,
    title: 'Promemoria: rinnovo contratto Giubra Srl in scadenza',
    description: 'Contratto annuale Giubra in scadenza ad aprile. Iniziare la trattativa di rinnovo entro fine febbraio per evitare gap di servizio.',
    ...auditAt('2026-01-05T08:00:00Z'),
  },
];
